import React, { createContext, ReactNode, useContext } from "react";
import SessionStorage from "../../../service/storage/SessionStorage";
import StorageKeys from "../../../const/StorageKeys";
import UtilityHelper from "../../../service/utilities/UtilityHelper";
import { appRoutes } from "../../../routes/routes";
import BranchSwitchSplashProvider from "./BranchSwitchSplashProvider";
import { SearchBranchList } from "../../../model/branch/BranchListModel";
import AppTheme from "../../../service/app_config/AppTheme";
import { navigate } from "../../../service/navigation/Navigation";

type BranchSwicthSplashContextType = {
  getBranchDetail: () => void;
};

const BranchSwicthSplashContext = createContext<
  BranchSwicthSplashContextType | undefined
>(undefined);

export const BranchSwicthSplashContextProvider = ({
  children,
}: {
  children: ReactNode;
}) => {
  const guestStatus: string =
    SessionStorage.getValue(StorageKeys.guest_status) || "0";

  const redirect = () => {
    // APPLY BRANCH THEME
    AppTheme.init();
    navigate(
      guestStatus === "1"
        ? appRoutes.routeNameHomeGuest
        : appRoutes.routeNameHome,
      { replace: true }
    );
    /* window.location.replace(
      guestStatus === "1"
        ? appRoutes.routeNameHomeGuest
        : appRoutes.routeNameHome
    ); */
  };

  const getBranchDetail = async () => {
    const branchBoardingSession = SessionStorage.getValue(
      StorageKeys.branch_detail_boarding
    );

    if (
      UtilityHelper.isNotEmpty(branchBoardingSession) &&
      guestStatus !== "1"
    ) {
      const branchDetail: SearchBranchList = JSON.parse(branchBoardingSession);
      await BranchSwitchSplashProvider.setupBranchTheme(
        branchDetail.branch_id!
      );

      /*  if (guestStatus === "1") {
        BranchSwitchSplashProvider.applyBranchThemeConfig({
          company_theme_color: UtilityHelper.isNotEmpty(
            branchDetail.branch_flash_colour!
          )
            ? branchDetail.branch_flash_colour
            : AppTheme.themeFontDefault,
        });
      } else { */
      /* const branchInfoResult = await HomeProvider.getBranchDetail(
        branchDetail.branch_id
      );

      if (branchInfoResult != null) {
        const branchConfig: BranchConfigurationDetails =
          branchInfoResult.result?.branch_info?.branch_configuration_details ??
          {};

        SessionStorage.deleteValue(StorageKeys.home_branch_detail);
        BranchSwitchSplashProvider.applyBranchThemeConfig(branchConfig);
      } */
      //}
    }

    redirect();
  };

  return (
    <BranchSwicthSplashContext.Provider
      value={{
        getBranchDetail,
      }}
    >
      {children}
    </BranchSwicthSplashContext.Provider>
  );
};

// IMPORT / USE CONTEXT ///////////////////////////////////////////////////////////////////
export const BranchSwicthSplashContextImport = () => {
  const context = useContext(BranchSwicthSplashContext);
  if (!context) {
    throw new Error(
      "BranchSwicthSplashContextImport must be used within a BranchSwicthSplashContextProvider"
    );
  }
  return context;
};
